import React from "react";
import { makeStyles } from "@material-ui/styles";
import PropTypes from 'prop-types';
import DeviceAddForm from "./DeviceAddForm";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
}));


const DeviceAdd = (props) => {

  const {className, history, ...rest } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <DeviceAddForm history={history} />
      </div>
    </div>
  );
};

DeviceAdd.propTypes = {
  history: PropTypes.object
};

export default DeviceAdd;
